var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainBusinessD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1830",
    "data-name": "\\uC0AC\\uAC01\\uD615 1830",
    width: 69.129,
    height: 59.253,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4012",
    "data-name": "\\uADF8\\uB8F9 4012",
    transform: "translate(1250 8483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4000",
    "data-name": "\\uADF8\\uB8F9 4000",
    transform: "translate(-1229.565 -8464.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3999",
    "data-name": "\\uADF8\\uB8F9 3999",
    transform: "translate(-0.435 -0.374)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_128",
    "data-name": "\\uD328\\uC2A4 128",
    d: "M14.421,21.508a5.551,5.551,0,1,1,5.552-5.551,5.558,5.558,0,0,1-5.552,5.551m0-8.784a3.233,3.233,0,1,0,3.233,3.233,3.237,3.237,0,0,0-3.233-3.233",
    transform: "translate(-2.015 -2.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_129",
    "data-name": "\\uD328\\uC2A4 129",
    d: "M49.23,21.674a6.819,6.819,0,1,1,6.819-6.818,6.827,6.827,0,0,1-6.819,6.818m0-11.052a4.233,4.233,0,1,0,4.234,4.234,4.238,4.238,0,0,0-4.234-4.234",
    transform: "translate(-10.342 -2.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130",
    "data-name": "\\uD328\\uC2A4 130",
    d: "M47.244,33.772H2.807A2.81,2.81,0,0,0,0,36.579V64.12a2.81,2.81,0,0,0,2.807,2.807H47.244a2.81,2.81,0,0,0,2.807-2.807V36.579a2.81,2.81,0,0,0-2.807-2.807M2.807,36.09H47.244a.488.488,0,0,1,.488.488v6.3H2.318v-6.3a.488.488,0,0,1,.488-.488M47.244,64.608H2.807a.488.488,0,0,1-.488-.488V45.2H47.732V64.12a.488.488,0,0,1-.488.488",
    transform: "translate(0 -7.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131",
    "data-name": "\\uD328\\uC2A4 131",
    d: "M83.092,34.883a2.058,2.058,0,0,0-2.059-.03L67.016,42.581A2.078,2.078,0,0,0,65.942,44.4V56.671a2.079,2.079,0,0,0,1.074,1.819l14.017,7.728h0A2.076,2.076,0,0,0,84.112,64.4V36.672a2.059,2.059,0,0,0-1.02-1.788M68.26,44.542l7.192-3.965V60.493L68.26,56.529ZM81.794,63.99,77.77,61.771V39.3l4.024-2.218Z",
    transform: "translate(-14.983 -7.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132",
    "data-name": "\\uD328\\uC2A4 132",
    d: "M39.285,0c-.037,0-.073.005-.111.006h-.006a12.317,12.317,0,0,0-2.04.2L12.692,2.542A11.077,11.077,0,1,0,18.754,4.29L31.136,3.1A12.3,12.3,0,1,0,39.285,0M21.54,13.592A8.738,8.738,0,1,1,12.8,4.855a8.748,8.748,0,0,1,8.738,8.737M39.285,22.33A10,10,0,0,1,37.367,2.508l1.954-.187a10,10,0,0,1-.036,20.01",
    transform: "translate(-0.397 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1834",
    "data-name": "\\uC0AC\\uAC01\\uD615 1834",
    width: 100,
    height: 100,
    transform: "translate(-1250 -8483)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBusinessD);
export default __webpack_public_path__ + "static/media/main_business_d.1f498a9ae86b5b04c25b3f99627326d1.svg";
export { ForwardRef as ReactComponent };